"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// src/data/Products_13.ts
const product_types_1 = require("../types/product.types");
const products = [
    // 1193. Curs Online Policia Local eL Prat de Llobregat (2026)
    {
        id: 1193,
        tax: 0.21,
        category: [product_types_1.Category.Online, product_types_1.Category.PL],
        sku: "iopos.course.online.curs-online-policia-local-el-prat-2026",
        title: "Curs Online Policia Local El Prat (2026)",
        name: "Curs Online Policia Local El Prat (2026)",
        description: "Prepara't amb garanties i aconsegueix la teva plaça amb el curs més complet per a Policia Local El Prat 2026.",
        enabled: true,
        stock: false,
        stock_message: "No disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 19.99,
        offer: 79.99,
        offer_message: "Oferta exclusiva!",
        offer_text: "Oferta exclusiva!",
        shipment: 0.0,
        images: ["/1193/image_h"],
        banner: ["/1193/image_h"],
        link: "/tienda/cursos/curs-online-policia-local-el-prat-2026/",
        created_at: "2026-03-30 00:00:01",
        start_at: "2026-03-30 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        evolmind: {
            course_id: 1252,
            group_id: [3115],
        },
        hero: {
            firstTitle: "Curs Online Policia Local El Prat de Llobregat",
            secondTitle: "Convocatòria 2026",
            thirdTitle: "Prepara't amb garanties i **aconsegueix la teva plaça**",
            landscape: "/1193/hero_h",
            portrait: "/1193/hero_v",
        },
        productImage: {
            landscape: "/1193/image_h",
            portrait: "/1193/image_v",
        },
        availableUntilExam: true,
    },
    // 1194. Curs Online Policia Local de Sabadell (2026)
    {
        id: 1194,
        tax: 0.21,
        category: [product_types_1.Category.Online, product_types_1.Category.PL],
        sku: "iopos.course.online.curs-online-policia-local-de-sabadell-2026",
        title: "Curs Online Policia Local de Sabadell (2026)",
        name: "Curs Online Policia Local de Sabadell (2026)",
        description: "Si vols destacar entre els aspirants, aquest és el curs que marca la diferència.",
        enabled: true,
        stock: false,
        stock_message: "No disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 19.99,
        offer: 79.99,
        offer_message: "Oferta exclusiva!",
        offer_text: "Oferta exclusiva!",
        shipment: 0.0,
        images: ["/1194/image_h"],
        banner: ["/1194/image_h"],
        link: "/tienda/cursos/curs-online-policia-local-de-sabadell-2026/",
        created_at: "2026-04-08 00:00:01",
        start_at: "2026-04-08 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        evolmind: {
            course_id: 1264,
            group_id: [3148],
        },
        productImage: {
            landscape: "/1194/image_h",
            portrait: "/1194/image_v",
        },
        hero: {
            firstTitle: "Curs Online Policia Local de Sabadell",
            secondTitle: "Convocatòria 2026",
            thirdTitle: "Si vols **destacar** entre els aspirants, aquest és el curs que **marca la diferència**.",
            landscape: "/1194/hero_h",
            portrait: "/1194/hero_v",
        },
        availableUntilExam: true,
    },
    // 1195. Sessió Espai Bulevard (5h)
    {
        id: 1195,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.sessio-espai-bulevard-5hores-2026",
        title: "Sessió Espai Bulevard (5h)",
        name: "Sessió Espai Bulevard (5h)",
        description: "Practica i aplica en 5 hores allò que marcarà la diferència a l'ISPC.",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 49.99,
        images: ["/940/image1"],
        banner: ["/940/image1"],
        link: "/tienda/cursos/sessio-espai-bulevard-5hores-2026/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        created_at: "2026-03-23 00:00:10",
        start_at: "2026-03-23 00:00:10",
        updated_at: "2026-03-23 00:00:10",
        notify_emails: ["tonicalvo@iopos.academy"],
        childs: [1196, 1197, 1198, 1200, 1215, 1216, 1217, 1218],
    },
    // 1196. Sessió Espai Bulevard - 28/03/2026
    {
        id: 1196,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.sessio-espai-bulevard-5hores-28-03-2026",
        title: "Sessió Espai Bulevard (5h) - 28/03/2026",
        name: "Sessió Espai Bulevard (5h) - 28/03/2026",
        short: "Sessió Espai Bulevard (5h) - 28/03/2026",
        description: "Practica i aplica en 5 hores allò que marcarà la diferència a l'ISPC.",
        enabled: true,
        stock: false,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 49.99,
        images: ["/940/image1"],
        banner: ["/940/image1"],
        link: "/tienda/cursos/sessio-espai-bulevard-5hores-28-03-2026/",
        more_info: false,
        can_be_sent: false,
        items: 1,
        created_at: "2026-03-23 00:00:10",
        start_at: "2026-03-23 00:00:10",
        updated_at: "2026-03-23 00:00:10",
        notify_emails: ["tonicalvo@iopos.academy"],
        evolmind: { course_id: 894, group_id: [3154] },
        parent: 1195,
    },
    // 1197. Sessió Espai Bulevard - 11/04/2026
    {
        id: 1197,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.sessio-espai-bulevard-5hores-11-04-2026",
        title: "Sessió Espai Bulevard (5h) - 11/04/2026",
        name: "Sessió Espai Bulevard (5h) - 11/04/2026",
        short: "Sessió Espai Bulevard (5h) - 11/04/2026",
        description: "Practica i aplica en 5 hores allò que marcarà la diferència a l'ISPC.",
        enabled: true,
        stock: false,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 49.99,
        images: ["/940/image1"],
        banner: ["/940/image1"],
        link: "/tienda/cursos/sessio-espai-bulevard-5hores-11-04-2026/",
        more_info: false,
        can_be_sent: false,
        items: 1,
        created_at: "2026-03-23 00:00:10",
        start_at: "2026-03-23 00:00:10",
        updated_at: "2026-03-23 00:00:10",
        notify_emails: ["tonicalvo@iopos.academy"],
        evolmind: { course_id: 894, group_id: [3157] },
        parent: 1195,
    },
    // 1198. Sessió Espai Bulevard - 25/04/2026
    {
        id: 1198,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.sessio-espai-bulevard-5hores-25-04-2026",
        title: "Sessió Espai Bulevard (5h) - 25/04/2026",
        name: "Sessió Espai Bulevard (5h) - 25/04/2026",
        short: "Sessió Espai Bulevard (5h) - 25/04/2026",
        description: "Practica i aplica en 5 hores allò que marcarà la diferència a l'ISPC.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 49.99,
        images: ["/940/image1"],
        banner: ["/940/image1"],
        link: "/tienda/cursos/sessio-espai-bulevard-5hores-25-04-2026/",
        more_info: false,
        can_be_sent: false,
        items: 1,
        created_at: "2026-03-23 00:00:10",
        start_at: "2026-03-23 00:00:10",
        updated_at: "2026-03-23 00:00:10",
        notify_emails: ["tonicalvo@iopos.academy"],
        evolmind: { course_id: 894, group_id: [3160] },
        parent: 1195,
    },
    // 1199. Pack Intensiu Sessió Espai Bulevard (3 sessions)
    {
        id: 1199,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.pack-sessio-espai-bulevard-3-sessions-2026",
        title: "Pack Intensiu Sessió Espai Bulevard (3 sessions)",
        name: "Pack Intensiu Sessió Espai Bulevard (3 sessions)",
        description: "Entrena el Bulevard com toca: amb continuïtat, seguretat i millor preu.",
        enabled: false,
        stock: false,
        stock_message: "No disponible!",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 119.99,
        offer: 149.97,
        offer_message: "Aprofita el pack intensiu i estalvia un 20% respecte a comprar les sessions per separat!",
        images: ["/1199/image_h"],
        banner: ["/1199/image_h"],
        link: "/tienda/cursos/pack-intensiu-sessio-espai-bulevard-3-sessions-2026/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        created_at: "2026-03-24 00:00:10",
        start_at: "2026-03-24 00:00:10",
        updated_at: "2026-03-24 00:00:10",
        notify_emails: ["tonicalvo@iopos.academy"],
        evolmind: { course_id: 894, group_id: [3154, 3157, 3160] },
        productImage: {
            landscape: "/1199/image_h",
            portrait: "/1199/image_v",
        },
        hero: {
            firstTitle: "Pack Intensiu Sessió Espai Bulevard",
            secondTitle: "3 sessions",
            thirdTitle: "Entrena el Bulevard amb **continuïtat real**, més **seguretat** i un preu més **avantatjós**.",
            landscape: "/1199/hero_h",
            portrait: "/1199/hero_v",
        },
    },
    // 1200. Sessió Espai Bulevard - 29/03/2026
    {
        id: 1200,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.sessio-espai-bulevard-5hores-29-03-2026",
        title: "Sessió Espai Bulevard (5h) - 29/03/2026",
        name: "Sessió Espai Bulevard (5h) - 29/03/2026",
        short: "Sessió Espai Bulevard (5h) - 29/03/2026",
        description: "Practica i aplica en 5 hores allò que marcarà la diferència a l'ISPC.",
        enabled: true,
        stock: false,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 49.99,
        images: ["/940/image1"],
        banner: ["/940/image1"],
        link: "/tienda/cursos/sessio-espai-bulevard-5hores-29-03-2026/",
        more_info: false,
        can_be_sent: false,
        items: 1,
        created_at: "2026-03-28 00:00:10",
        start_at: "2026-03-28 00:00:10",
        updated_at: "2026-03-28 00:00:10",
        notify_emails: ["tonicalvo@iopos.academy"],
        evolmind: { course_id: 894, group_id: [3163] },
        parent: 1195,
    },
    // 1201. Curs Intensiu Presencial Policia Local Terrassa (2026)
    {
        id: 1201,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-intensiu-presencial-policia-municipal-terrassa-18-abril-2026",
        title: "Curs Intensiu Presencial Policia Municipal de Terrassa 2026 (18 d'abril)",
        name: "Curs Intensiu Presencial Policia Municipal de Terrassa 2026 (18 d'abril)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.PL],
        description: "Prepara't en un sol dia amb el que realment marca la diferència i arriba a l'examen amb seguretat i criteri.",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        // offer: 99.99,
        offer_message: "Oferta de llançament les 10 primeres matrícules!",
        offer_text: "Oferta de llançament les 10 primeres matrícules!",
        shipment: 0.0,
        images: ["/1201/image_h"],
        link: "/tienda/cursos/curs-intensiu-presencial-policia-municipal-terrassa-18-abril-2026/",
        created_at: "2026-03-30 00:00:10",
        start_at: "2026-03-30 00:00:10",
        more_info: true,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1201/image_h",
            portrait: "/1201/image_v",
        },
        hero: {
            firstTitle: "Curs Presencial Policia Municipal de Terrassa",
            secondTitle: "Convocatòria 2026",
            thirdTitle: "Prepara't en un sol dia amb el que **realment marca la diferència** i arriba a l'examen amb **seguretat i criteri**.",
            landscape: "/1201/hero_h",
            portrait: "/1201/hero_v",
        },
        evolmind: {
            course_id: 1270,
            group_id: [3166],
        },
    },
    // 1202. Curs Presencial Mossos d'Esquadra (2026)
    {
        id: 1202,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-presencial-mossos-2026-30-hores",
        title: "Curs Presencial Mossos d'Esquadra 2026 (30 hores)",
        name: "Curs Presencial Mossos d'Esquadra 2026 (30 hores)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "Prepara Mossos amb estructura, criteri i confiança: 30 hores presencials que marquen la diferència el dia de l’examen",
        enabled: true,
        stock: false,
        stock_message: "Sense places",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 299.99,
        shipment: 0.0,
        images: ["/1202/image_h"],
        link: "/tienda/cursos/curs-presencial-mossos-desquadra-2026-30-hores/",
        created_at: "2026-03-30 00:00:10",
        start_at: "2026-03-30 00:00:10",
        more_info: true,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1202/image_h",
            portrait: "/1202/image_v",
        },
        hero: {
            firstTitle: "Curs Presencial Mossos d'Esquadra",
            secondTitle: "Convocatòria 2026",
            thirdTitle: "**Prepara Mossos amb estructura, criteri i confiança:** 30 hores presencials que marquen la diferència el dia de l'examen.",
            landscape: "/1202/hero_h",
            portrait: "/1202/hero_v",
        },
        childs: [1203, 1229, 1228, 1240, 1249, 1251],
    },
    // 1203. Curs Presencial Mossos d'Esquadra (2026) - Grup Dissabtes Matí
    {
        id: 1203,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-presencial-mossos-2026-30-hores-g1",
        title: "Curs Presencial Mossos d'Esquadra 2026 (30 hores) - Grup 1 - Dissabtes Matí",
        name: "Curs Presencial Mossos d'Esquadra 2026 (30 hores) - Grup 1 - Dissabtes Matí",
        short: "Curs Presencial Mossos - Grup 1 (Dissabtes Matí)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "Prepara Mossos amb estructura, criteri i confiança: 30 hores presencials que marquen la diferència el dia de l’examen",
        enabled: true,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 299.99,
        // offer: 299.99,
        // offer_message: "Oferta de llançament!",
        // offer_text: "Oferta de llançament!",
        shipment: 0.0,
        images: ["/1202/image_h"],
        link: "/tienda/cursos/curs-presencial-mossos-desquadra-2026-30-hores/",
        created_at: "2026-03-30 00:00:10",
        start_at: "2026-03-30 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1202/image_h",
            portrait: "/1202/image_v",
        },
        hero: {
            firstTitle: "Curs Presencial Mossos d'Esquadra",
            secondTitle: "Convocatòria 2026",
            thirdTitle: "**Prepara Mossos amb estructura, criteri i confiança:** 30 hores presencials que marquen la diferència el dia de l'examen.",
            landscape: "/1202/hero_h",
            portrait: "/1202/hero_v",
        },
        parent: 1202,
        evolmind: {
            course_id: 1267,
            group_id: [3172],
        },
    },
    // 1204. Curs Presencial ACTIC nivell mitjà (14 h) - Edició #3: 2 i 3 de maig 2026
    {
        id: 1204,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Others],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.2025-curs-presencial-actic-nivell-mitja-14h-2-3-maig-2026",
        title: "Curs Presencial ACTIC nivell mitjà (14 h - 2 i 3 de maig de 10:00 a 17:00 h)",
        name: "Curs Presencial ACTIC nivell mitjà (14 h - 2 i 3 de maig de 10:00 a 17:00 h)",
        short: "3.) Curs ACTIC nivell mitjà (2 i 3 de maig de 10:00 - 17:00)",
        description: "Aconsegueix el certificat ACTIC nivell mitjà en només 3 dies amb el nostre curs intensiu i presencial. Ràpid, efectiu i amb suport personalitzat!",
        enabled: true,
        stock: false,
        stock_message: "Aviat disponible!",
        price: 89.99,
        shipment: 0.0,
        images: ["/807/image5"],
        banner: ["/807/image5"],
        link: "/tienda/cursos/curs-presencial-actic-nivell-mitja-14h-2-3-maig-2026/",
        created_at: "2026-04-14 00:00:01",
        start_at: "2026-04-14 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 807,
        limit: 30,
        default_in_parent: true,
        evolmind: { course_id: 492, group_id: [3175] },
    },
    // 1205. Dossier Esquematitzat Policia Municipal Terrassa (2026)
    {
        id: 1205,
        tax: 0.04,
        sku: "iopos.book.dossier-esquematitzat-policia-municipal-terrassa-2026",
        title: "Dossier Esquematitzat Policia Municipal Terrassa (2026)",
        name: "Dossier Esquematitzat Policia Municipal Terrassa (2026)",
        category: [product_types_1.Category.Books, product_types_1.Category.PL],
        description: "Estudia menys temps, retén més informació i arriba a l’examen amb avantatge real gràcies a un dossier pensat per anar directament al que importa.",
        enabled: true,
        stock: false,
        stock_message: "Sense estoc!",
        type: product_types_1.Type.Book,
        price: 9.99,
        offer: 39.99,
        offer_message: "Oferta exclusiva!",
        offer_text: "Oferta exclusiva!",
        shipment: 4.49,
        images: ["/1205/image_h"],
        link: "/tienda/cursos/dossier-esquematitzat-policia-municipal-terrassa-2026/",
        created_at: "2026-04-15 00:00:10",
        start_at: "2026-04-15 00:00:10",
        more_info: true,
        can_be_sent: true,
        items: 1,
        productImage: {
            landscape: "/1205/image_h",
            portrait: "/1205/image_h",
        },
        hero: {
            firstTitle: "Dossier Esquematitzat Policia Municipal de Terrassa",
            secondTitle: "Convocatòria 2026",
            thirdTitle: "Estudia **menys temps**, retén **més informació** i arriba a l’examen amb **avantatge real** gràcies a un dossier pensat per anar **directament al que importa**.",
            landscape: "/1205/image_h",
            portrait: "/1205/image_h",
        },
        weight: 580,
    },
    // 1206. Curs Presencial ACTIC nivell mitjà (14 h) - Edició #3: 2 i 3 de maig 2026
    {
        id: 1206,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Others],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.2025-curs-presencial-actic-nivell-mitja-14h-22-25-maig-2026",
        title: "Curs Presencial ACTIC nivell mitjà (14 h - 22 i 25 de maig de 10:00 a 17:00 h)",
        name: "Curs Presencial ACTIC nivell mitjà (14 h - 22 i 25 de maig de 10:00 a 17:00 h)",
        short: "4.) Curs ACTIC nivell mitjà (22 i 25 de maig de 10:00 - 17:00)",
        description: "Aconsegueix el certificat ACTIC nivell mitjà en només 3 dies amb el nostre curs intensiu i presencial. Ràpid, efectiu i amb suport personalitzat!",
        enabled: true,
        stock: false,
        stock_message: "Aviat disponible!",
        price: 89.99,
        shipment: 0.0,
        images: ["/807/image5"],
        banner: ["/807/image5"],
        link: "/tienda/cursos/curs-presencial-actic-nivell-mitja-14h-2-3-maig-2026/",
        created_at: "2026-04-14 00:00:01",
        start_at: "2026-04-14 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 807,
        limit: 30,
        default_in_parent: true,
        evolmind: { course_id: 492, group_id: [3178] },
    },
    // 1207. Curs Presencial Psicotècnics Aptitudinals (8 hores - 28 de Març)
    {
        id: 1207,
        type: product_types_1.Type.Course,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA), al tratarse de una formación homologada por una entidad oficial.",
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-16-maig-2026",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (16/05 · 9-18h)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2026 [8h] (16/05 · 9-18h)",
        short: "2.) Presencial de Psicos. Mossos 2026 (16 maig - 9:00h a 18:00 h)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2025.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 109.99,
        shipment: 0.0,
        images: ["/939/image1_h"],
        banner: ["/939/image1_h"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-16-maig-2026/",
        created_at: "2025-11-06 00:00:01",
        start_at: "2025-11-06 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 939,
        limit: 30,
    },
    // 1208. Curs Online Policia Local de Manresa (2026)
    {
        id: 1208,
        tax: 0.21,
        category: [product_types_1.Category.Online, product_types_1.Category.PL],
        sku: "iopos.course.online.curs-online-policia-local-de-manresa-2026",
        title: "Curs Online Policia Local de Manresa (2026)",
        name: "Curs Online Policia Local de Manresa (2026)",
        description: "Si vols anar a l’examen amb opcions reals d’aprovar, aquest curs és el teu punt de partida.",
        enabled: true,
        stock: false,
        stock_message: "No disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 19.99,
        offer: 79.99,
        // offer_message: "Oferta de llançament les 10 primeres matrícules!",
        // offer_text: "Oferta de llançament les 10 primeres matrícules!",
        shipment: 0.0,
        images: ["/1208/image_h"],
        banner: ["/1208/image_h"],
        link: "/tienda/cursos/curs-online-policia-local-de-manresa-2026/",
        created_at: "2026-05-08 00:00:01",
        start_at: "2026-05-08 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        evolmind: {
            course_id: 1276,
            group_id: [3181],
        },
        productImage: {
            landscape: "/1208/image_h",
            portrait: "/1208/image_v",
        },
        hero: {
            firstTitle: "Curs Online Policia Local de Manresa",
            secondTitle: "Convocatòria 2026",
            thirdTitle: "Si vols anar a l’examen amb **opcions reals d’aprovar**, aquest curs és el teu **punt de partida**.",
            landscape: "/1208/hero_h",
            portrait: "/1208/hero_v",
        },
        availableUntilExam: true,
    },
    // 1209. Curs Desbloqueig Mental Físiques (Valla i Plint) 2026 [2h] (2026)
    {
        id: 1209,
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.curs-desbloqueig-mental-fisiques-2026",
        title: "Curs Desbloqueig Mental Físiques (Valla i Plint) 2026 [2h]",
        name: "Curs Desbloqueig Mental Físiques (Valla i Plint) 2026 [2h]",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        description: "Supera la por, trenca els bloquejos i arriba al dia de la prova amb el control total: domina la tanca i el plintó amb el mètode mental d’iOpos.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 24.99,
        shipment: 0.0,
        images: ["/944/image1"],
        banner: ["/944/image1"],
        link: "/tienda/cursos/curs-desbloqueig-mental-fisiques-4-juliol-2026/",
        created_at: "2026-04-26 00:00:01",
        start_at: "2026-04-26 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        discount_not_applicable: false,
        childs: [1211],
    },
    // 1210. Curs Online d'Orientació a l'ISPC 40a Promoció (2026)
    {
        id: 1210,
        tax: 0.21,
        category: [product_types_1.Category.Online, product_types_1.Category.ISPC, product_types_1.Category.Bulevard],
        sku: "iopos.course.online.curs-online-orientacio-ispc-40a-promocio-2026",
        title: "Curs Online d'Orientació a l'ISPC 40ª Promoció (2026)",
        name: "Curs Online d'Orientació a l'ISPC 40ª Promoció (2026)",
        description: "Comença abans que ningú i arriba millor preparat que la resta.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 89.99,
        shipment: 0.0,
        images: ["/1210/image_h"],
        banner: ["/1210/image_h"],
        link: "/tienda/cursos/curs-online-orientacio-ispc-40a-promocio-2026/",
        created_at: "2026-04-26 00:00:01",
        start_at: "2026-04-26 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        evolmind: {
            course_id: 1279,
            group_id: [3184],
        },
        productImage: {
            landscape: "/1210/image_h",
            portrait: "/1210/image_v",
        },
        hero: {
            firstTitle: "Curs Online d'Orientació a l'ISPC",
            secondTitle: "40ª Promoció (2026)",
            thirdTitle: "Comença avui el que la resta començarà tard",
            landscape: "/1210/hero_h",
            portrait: "/1210/hero_v",
        },
    },
    // 1211. Curs Desbloqueig Mental Físiques (Valla i Plint) 2026 [2h] (04/07/2026 9 a 11h)
    {
        id: 1211,
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.curs-desbloqueig-mental-fisiques-04_07_2026-9-11",
        title: "Curs Desbloqueig Mental Físiques (Valla i Plint) 04/07/2026 9 a 11 [2h]",
        name: "Curs Desbloqueig Mental Físiques (Valla i Plint) 04/07/2026 9 a 11 [2h]",
        short: "Sessió 04/07/2026 9 a 11 [2h] - Desbloqueig Mental Físiques (Valla i Plint)",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        description: "Supera la por, trenca els bloquejos i arriba al dia de la prova amb el control total: domina la tanca i el plintó amb el mètode mental d’iOpos.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 24.99,
        shipment: 0.0,
        images: ["/944/image1"],
        banner: ["/944/image1"],
        link: "/tienda/cursos/curs-desbloqueig-mental-fisiques-4-juliol-2026/",
        created_at: "2026-04-26 00:00:01",
        start_at: "2026-04-26 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        discount_not_applicable: false,
        parent: 1209,
    },
    // 1212. Formació Role Play - Policies Locals (25 maig 2026)
    {
        id: 1212,
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.cursformacio-role-play-pl-24-maig-2026",
        title: "Formació Role Play - Policies Locals (24 maig 2026)",
        name: "Formació Role Play - Policies Locals (24 maig 2026)",
        category: [product_types_1.Category.PL, product_types_1.Category.FaceToFace],
        description: "Reserva la teva plaça i entrena l’entrevista com ho faràs el dia real.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 89.99,
        shipment: 0.0,
        images: ["/1212/image_h"],
        banner: ["/1212/image_h"],
        link: "/tienda/cursos/formacio-role-play-policies-locals-24-maig-2026/",
        created_at: "2026-04-27 00:00:01",
        start_at: "2026-04-27 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1212/image_h",
            portrait: "/1212/image_v",
        },
        hero: {
            firstTitle: "Formació Role Play",
            secondTitle: "Per Policies Locals",
            thirdTitle: "Reserva la teva plaça i entrena l’entrevista com ho faràs el dia real.",
            landscape: "/1212/hero_h",
            portrait: "/1212/hero_v",
        },
        evolmind: {
            course_id: 1282,
            group_id: [3187],
        },
    },
    // 1213. Curs Online Guàrdia Urbana de Badalona (2026)
    {
        id: 1213,
        tax: 0.21,
        category: [product_types_1.Category.Online, product_types_1.Category.PL],
        sku: "iopos.course.online.curs-online-guarda-urbana-badalona-2026",
        title: "Curs Online Guàrdia Urbana de Badalona (2026)",
        name: "Curs Online Guàrdia Urbana de Badalona (2026)",
        description: "La manera més clara i efectiva de preparar la Guàrdia Urbana de Badalona amb criteri i arribar a l’examen amb confiança.",
        enabled: true,
        stock: false,
        stock_message: "No disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 19.99,
        offer: 79.99,
        offer_message: "Últim sprint!",
        offer_text: "Últim sprint!",
        shipment: 0.0,
        images: ["/1213/image_h"],
        banner: ["/1213/image_h"],
        link: "/tienda/cursos/curs-online-guarda-urbana-badalona-2026/",
        created_at: "2026-06-16 00:00:01",
        start_at: "2026-06-16 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        evolmind: {
            course_id: 1291,
            group_id: [3196],
        },
        productImage: {
            landscape: "/1213/image_h",
            portrait: "/1213/image_v",
        },
        hero: {
            firstTitle: "Curs Online Guàrdia Urbana de Badalona",
            secondTitle: "Edició 2026",
            thirdTitle: "La manera més clara i efectiva de preparar la Guàrdia Urbana de Badalona amb criteri i arribar a l’examen amb confiança.",
            landscape: "/1213/hero_h",
            portrait: "/1213/hero_v",
        },
        availableUntilExam: true,
    },
    // 1214. Curs Online Guàrdia Urbana de l'Hospitalet (2026)
    {
        id: 1214,
        tax: 0.21,
        category: [product_types_1.Category.Online, product_types_1.Category.PL],
        sku: "iopos.course.online.curs-online-guarda-urbana-hospitalet-2026",
        title: "Curs Online Guàrdia Urbana de l'Hospitalet (2026)",
        name: "Curs Online Guàrdia Urbana de l'Hospitalet (2026)",
        description: "Tot el que necessites per preparar la Guàrdia Urbana de L’Hospitalet amb seguretat, estructura i enfocament real a l’examen.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 19.99,
        offer: 79.99,
        offer_message: "Últim sprint!",
        offer_text: "Últim sprint!",
        shipment: 0.0,
        images: ["/1214/image_h"],
        banner: ["/1214/image_h"],
        link: "/tienda/cursos/curs-online-guarda-urbana-hospitalet-2026/",
        created_at: "2026-04-26 00:00:01",
        start_at: "2026-04-26 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        evolmind: {
            course_id: 1285,
            group_id: [3190],
        },
        productImage: {
            landscape: "/1214/image_h",
            portrait: "/1214/image_v",
        },
        hero: {
            firstTitle: "Curs Online Guàrdia Urbana de l'Hospitalet",
            secondTitle: "Edició 2026",
            thirdTitle: "Tot el que necessites per preparar la Guàrdia Urbana de L’Hospitalet amb seguretat, estructura i enfocament real a l’examen.",
            landscape: "/1214/hero_h",
            portrait: "/1214/hero_v",
        },
        availableUntilExam: true,
    },
    // 1215. Sessió Espai Bulevard - 02/05/2026
    {
        id: 1215,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.sessio-espai-bulevard-5hores-02-05-2026",
        title: "Sessió Espai Bulevard (5h) - 02/05/2026",
        name: "Sessió Espai Bulevard (5h) - 02/05/2026",
        short: "Sessió Espai Bulevard (5h) - 02/05/2026",
        description: "Practica i aplica en 5 hores allò que marcarà la diferència a l'ISPC.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 49.99,
        images: ["/940/image1"],
        banner: ["/940/image1"],
        link: "/tienda/cursos/sessio-espai-bulevard-5hores-25-04-2026/",
        more_info: false,
        can_be_sent: false,
        items: 1,
        created_at: "2026-05-01 00:00:10",
        start_at: "2026-05-01 00:00:10",
        updated_at: "2026-05-01 00:00:10",
        notify_emails: ["tonicalvo@iopos.academy"],
        evolmind: { course_id: 894, group_id: [3199] },
        parent: 1195,
    },
    // 1216. Sessió Espai Bulevard - 10/05/2026
    {
        id: 1216,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.sessio-espai-bulevard-5hores-10-05-2026",
        title: "Sessió Espai Bulevard (5h) - 10/05/2026",
        name: "Sessió Espai Bulevard (5h) - 10/05/2026",
        short: "Sessió Espai Bulevard (5h) - 10/05/2026",
        description: "Practica i aplica en 5 hores allò que marcarà la diferència a l'ISPC.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 49.99,
        images: ["/940/image1"],
        banner: ["/940/image1"],
        link: "/tienda/cursos/sessio-espai-bulevard-5hores-25-04-2026/",
        more_info: false,
        can_be_sent: false,
        items: 1,
        created_at: "2026-05-01 00:00:10",
        start_at: "2026-05-01 00:00:10",
        updated_at: "2026-05-01 00:00:10",
        notify_emails: ["tonicalvo@iopos.academy"],
        evolmind: { course_id: 894, group_id: [3202] },
        parent: 1195,
    },
    // 1217. Sessió Espai Bulevard - 16/05/2026
    {
        id: 1217,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.sessio-espai-bulevard-5hores-16-05-2026",
        title: "Sessió Espai Bulevard (5h) - 16/05/2026",
        name: "Sessió Espai Bulevard (5h) - 16/05/2026",
        short: "Sessió Espai Bulevard (5h) - 16/05/2026",
        description: "Practica i aplica en 5 hores allò que marcarà la diferència a l'ISPC.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 49.99,
        images: ["/940/image1"],
        banner: ["/940/image1"],
        link: "/tienda/cursos/sessio-espai-bulevard-5hores-16-05-2026/",
        more_info: false,
        can_be_sent: false,
        items: 1,
        created_at: "2026-05-01 00:00:10",
        start_at: "2026-05-01 00:00:10",
        updated_at: "2026-05-01 00:00:10",
        notify_emails: ["tonicalvo@iopos.academy"],
        evolmind: { course_id: 894, group_id: [3205] },
        parent: 1195,
    },
    // 1218. Sessió Espai Bulevard - 23/05/2026
    {
        id: 1218,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.sessio-espai-bulevard-5hores-23-05-2026",
        title: "Sessió Espai Bulevard (5h) - 23/05/2026",
        name: "Sessió Espai Bulevard (5h) - 23/05/2026",
        short: "Sessió Espai Bulevard (5h) - 23/05/2026",
        description: "Practica i aplica en 5 hores allò que marcarà la diferència a l'ISPC.",
        enabled: true,
        stock: true,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 49.99,
        images: ["/940/image1"],
        banner: ["/940/image1"],
        link: "/tienda/cursos/sessio-espai-bulevard-5hores-25-04-2026/",
        more_info: false,
        can_be_sent: false,
        items: 1,
        created_at: "2026-05-01 00:00:10",
        start_at: "2026-05-01 00:00:10",
        updated_at: "2026-05-01 00:00:10",
        notify_emails: ["tonicalvo@iopos.academy"],
        evolmind: { course_id: 894, group_id: [3208] },
        parent: 1195,
    },
    // 1219. Curs Online Actic Nivell Mitjà amb Examen Presencial (2026)
    {
        id: 1219,
        category: [product_types_1.Category.Online, product_types_1.Category.Others],
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        tax: 0.21,
        sku: "iopos.course.online.2026-curs-online-actic-nivell-mitja-10h-examen-presencial",
        title: "Curs Online ACTIC nivell mitjà + Examen presencial (10 h - 2026)",
        name: "Curs Online ACTIC nivell mitjà + Examen presencial (10 h - 2026)",
        description: "Prepara l’ACTIC amb una metodologia pràctica, clara i enfocada a examen perquè puguis obtenir l’acreditació amb més seguretat i sumar punts a la teva oposició.",
        enabled: true,
        stock: false,
        stock_message: "No disponible!",
        price: 89.99,
        shipment: 0.0,
        images: ["/1219/image_h"],
        banner: ["/1219/image_h"],
        link: "/tienda/cursos/curs-online-actic-nivell-mitja-examen-presencial-10h-2026/",
        created_at: "2026-05-11 00:00:01",
        start_at: "2026-05-11 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 492, group_id: [3211] },
        productImage: {
            landscape: "/1219/image_h",
            portrait: "/1219/image_v",
        },
        hero: {
            firstTitle: "Curs Online ACTIC nivell mitjà",
            secondTitle: "Amb Examen Presencial!",
            thirdTitle: "Prepara l’ACTIC amb una metodologia pràctica, clara i enfocada a examen perquè puguis obtenir l’acreditació amb més seguretat i sumar punts a la teva oposició",
            landscape: "/1219/hero_h",
            portrait: "/1219/hero_v",
        },
    },
    // 1220. Curs Online Psicotècnics Aptitudinals 2026 (12 hores)
    {
        id: 1220,
        tax: 0.21,
        sku: "iopos.course.online.curs-psicotecnics-apt-online-12-hores-2026",
        title: "Curs Online Psicotècnics Aptitudinals 2026 + Campus Online (12 hores)",
        name: "Curs Online Psicotècnics Aptitudinals 2026 + Campus Online (12 hores)",
        description: "Domina els psicotècnics en només 3 sessions intensives, en directe i amb accés al campus.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        category: [product_types_1.Category.Psicos, product_types_1.Category.Online],
        price: 49.99,
        offer: 99.99,
        offer_message: "Accedeix a totes les classes gravades a un preu reduït",
        offer_text: "Accedeix a totes les classes gravades a un preu reduït",
        images: ["/1220/image_h"],
        banner: ["/1220/image_h"],
        link: "/tienda/cursos/curs-online-psicotecnics-aptitudinals-12-hores-2026/",
        created_at: "2026-05-11 00:00:01",
        start_at: "2026-05-11 00:00:01",
        more_info: true,
        items: 1,
        productImage: {
            landscape: "/1220/image_h",
            portrait: "/1220/image_v",
        },
        hero: {
            firstTitle: "Curs Online Psicotècnics Aptitudinals 2026",
            secondTitle: "12 hores en directe",
            thirdTitle: "Aprèn a resoldre psicotècnics amb estratègia, rapidesa i confiança gràcies a una metodologia pràctica enfocada exactament al tipus d’exercicis que trobaràs a l’examen",
            landscape: "/1220/hero_h",
            portrait: "/1220/hero_v",
        },
        childs: [1221],
    },
    // 1221. Curs Online Psicotècnics Aptitudinals 2026 (12 hores) - Sessió 1
    {
        id: 1221,
        tax: 0.21,
        sku: "iopos.course.online.curs-psicotecnics-apt-online-12-hores-2026-g1",
        title: "Curs Online Psicotècnics Aptitudinals 2026 + Campus Online (12 hores)",
        name: "Curs Online Psicotècnics Aptitudinals 2026 + Campus Online (12 hores)",
        short: "Grup 1.) Curs Online Psicotècnics (26 juny, 3 i 8 de juliol)",
        description: "Domina els psicotècnics en només 3 sessions intensives, en directe i amb accés al campus.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        category: [product_types_1.Category.Psicos, product_types_1.Category.Online],
        price: 49.99,
        offer: 99.99,
        offer_message: "Accedeix a totes les classes gravades a un preu reduït",
        offer_text: "Accedeix a totes les classes gravades a un preu reduït",
        images: ["/1220/image_h"],
        banner: ["/1220/image_h"],
        link: "/tienda/cursos/curs-online-psicotecnics-aptitudinals-12-hores-2026/",
        created_at: "2026-05-11 00:00:01",
        start_at: "2026-05-11 00:00:01",
        more_info: false,
        items: 1,
        evolmind: { course_id: 1294, group_id: [3214] },
        productImage: {
            landscape: "/1220/image_h",
            portrait: "/1220/image_v",
        },
        hero: {
            firstTitle: "Curs Online Psicotècnics Aptitudinals 2026",
            secondTitle: "12 hores en directe",
            thirdTitle: "Aprèn a resoldre psicotècnics amb estratègia, rapidesa i confiança gràcies a una metodologia pràctica enfocada exactament al tipus d’exercicis que trobaràs a l’examen",
            landscape: "/1220/hero_h",
            portrait: "/1220/hero_v",
        },
        parent: 1220,
    },
    // 1122. Curs Semipresencial Homologat Dret Penal - 2026 (4 juliol)
    {
        id: 1122,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        tax: 0.0,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.ISPC,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
        ],
        sku: "iopos.course.f2f.curs-homologat-semipresencial-dret-penal-8-hores-4-juliol-2026",
        title: "Curs Homologat Semipresencial Dret Penal - 2026 (4 juliol)",
        name: "Curs Homologat Semipresencial Dret Penal - 2026 (4 juliol)",
        short: "5.) Curs Semipresencial Homologat Dret Penal (4 juliol 2026)",
        description: "Domina el Codi Penal amb una formació pràctica orientada a professionals dels cossos policials.",
        enabled: true,
        stock: false,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        // offer: 79.99,
        // offer_message: "Oferta de llançament les 20 primeres matrícules!",
        // offer_text: "Oferta de llançament les 20 primeres matrícules!",
        shipment: 0.0,
        images: ["/1185/image1"],
        banner: ["/1185/image1"],
        link: "/tienda/cursos/curs-semipresencial-homologat-dret-penal-29-03-2026/",
        created_at: "2026-03-15 00:00:01",
        start_at: "2026-03-15 00:00:01",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        evolmind: {
            course_id: 973,
            group_id: [3217],
        },
        homologated: [
            {
                code: "RP20250071042",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        productImage: {
            portrait: "/1185/image1_v",
            landscape: "/1185/image1_h",
        },
        hero: {
            portrait: "/1185/hero_v",
            landscape: "/1185/hero_h",
            firstTitle: "Curs Homologat Semipresencial Dret Penal",
            secondTitle: "ISPC 2026",
            thirdTitle: "**Domina el Codi Penal** amb una formació pràctica orientada a **professionals dels cossos policials**.",
        },
        parent: 1185,
    },
    // 1123. Curso Homologado Semipresencial Ley Orgánica 4 / 2015 (2026) Grup 3 Matí
    {
        id: 1123,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        tax: 0.0,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.ISPC,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
        ],
        sku: "iopos.course.f2f.curs-homologat-semipresencial-llei-organica-4-2015-4-hores-2026-13-juny-grup-mati",
        title: "Curs Homologat Semipresencial Llei Orgànica 4/2015 (2026) (13 juny - matí 8:30 a 12:30)",
        name: "Curs Homologat Semipresencial Llei Orgànica 4/2015 (2026) (13 juny - matí 8:30 a 12:30)",
        short: "3.) Curs Semipresencial Homologat Llei Orgànica 4/2015 (13 juny - matí 8:30 a 12:30)",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        // offer: 79.99,
        // offer_message: "Oferta de llançament les 20 primeres matrícules!",
        // offer_text: "Oferta de llançament les 20 primeres matrícules!",
        shipment: 0.0,
        images: ["/1187/image1_h"],
        banner: ["/1187/image1_h"],
        link: "/tienda/cursos/curs-semipresencial-homologat-llei-organica-4-2015-2026/",
        created_at: "2026-03-17 00:00:01",
        start_at: "2026-03-17 00:00:01",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        parent: 1187,
        evolmind: {
            course_id: 1114,
            group_id: [3220],
        },
        productImage: {
            portrait: "/1187/image1_v.jpg",
            landscape: "/1187/image1_h.jpg",
        },
        homologated: [
            {
                code: "RP20250070869",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
    },
    // 1224. Curs Presencial Psicotècnics Aptitudinals (8 hores - 14 de juny)
    {
        id: 1224,
        type: product_types_1.Type.Course,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA), al tratarse de una formación homologada por una entidad oficial.",
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-14-juny-2026",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (14/06 · 9-18h)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2026 [8h] (14/06 · 9-18h)",
        short: "3.) Presencial de Psicos. Mossos 2026 (14 juny - 9:00h a 18:00 h)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2025.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 109.99,
        shipment: 0.0,
        images: ["/939/image1_h"],
        banner: ["/939/image1_h"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-14-juny-2026/",
        created_at: "2025-11-06 00:00:01",
        start_at: "2025-11-06 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 939,
        limit: 30,
    },
    // 1225. Curs Presencial Psicotècnics Aptitudinals (8 hores - 25 i 26 de juny matí)
    {
        id: 1225,
        type: product_types_1.Type.Course,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA), al tratarse de una formación homologada por una entidad oficial.",
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-25-26-juny-2026",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (25 i 26/06 · 10-14h)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2026 [8h] (25 i 26/06 · 10-14h)",
        short: "4.) Presencial de Psicos. Mossos 2026 (25 i 26 juny - 10:00h a 14:00 h)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2025.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 109.99,
        shipment: 0.0,
        images: ["/939/image1_h"],
        banner: ["/939/image1_h"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-25-i-26-juny-2026/",
        created_at: "2025-11-06 00:00:01",
        start_at: "2025-11-06 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 939,
        limit: 30,
    },
    // 1226. Curs Presencial Psicotècnics Aptitudinals (8 hores - 25 i 26 de juny tarda)
    {
        id: 1226,
        type: product_types_1.Type.Course,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-25-26-juny-2026-tarda",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (25 i 26/06 · 15-19h)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2026 [8h] (25 i 26/06 · 15-19h)",
        short: "5.) Presencial de Psicos. Mossos 2026 (25 i 26 juny - 15:00h a 19:00 h)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2025.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 109.99,
        shipment: 0.0,
        images: ["/939/image1_h"],
        banner: ["/939/image1_h"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-25-i-26-juny-2026-tarda/",
        created_at: "2025-11-06 00:00:01",
        start_at: "2025-11-06 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 939,
        limit: 30,
    },
    // 1227. MasterClass Casos Pràctics Policia Local - 21 Maig
    {
        id: 1227,
        type: product_types_1.Type.Course,
        tax: 0.21,
        // tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.classroom.masterclass-casos-practics-policia-local-21-maig-2026",
        title: "MasterClass Casos Pràctics Policia Local (21/05/2026)",
        name: "MasterClass Casos Pràctics Policia Local (21/05/2026)",
        category: [product_types_1.Category.PL, product_types_1.Category.Online],
        description: "Els casos pràctics no s’improvisen: s’entrenen amb criteri i estratègia.",
        subtype: product_types_1.Subtype.Online,
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 19.99,
        shipment: 0.0,
        images: ["/1227/image_h"],
        banner: ["/1227/image_h"],
        link: "/tienda/cursos/masterclass-casos-practics-policia-local-21-maig-2026/",
        created_at: "2026-05-19 00:00:01",
        start_at: "2026-05-19 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        hero: {
            firstTitle: "MasterClass Casos Pràctics Policia Local",
            secondTitle: "Sessió online en viu per Zoom",
            thirdTitle: "Una **masterclass** pensada perquè sàpigues què respondre… i com respondre-ho.",
            landscape: "/1227/hero_h",
            portrait: "/1227/hero_v",
        },
        evolmind: {
            course_id: 1297,
            group_id: [3223],
        },
    },
    // 1228. Curs Presencial Mossos d'Esquadra (2026) - Grup Dimarts i Dijous Tarda
    {
        id: 1228,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-presencial-mossos-2026-30-hores-g3",
        title: "Curs Presencial Mossos d'Esquadra 2026 (30 hores) - Grup 3 - Dimarts i Dijous",
        name: "Curs Presencial Mossos d'Esquadra 2026 (30 hores) - Grup 3 - Dimarts i Dijous",
        short: "Curs Presencial Mossos - Grup 3 (Dimarts i Dijous)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "Prepara Mossos amb estructura, criteri i confiança: 30 hores presencials que marquen la diferència el dia de l’examen",
        enabled: true,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 299.99,
        // offer: 299.99,
        // offer_message: "Oferta de llançament!",
        // offer_text: "Oferta de llançament!",
        shipment: 0.0,
        images: ["/1202/image_h"],
        link: "/tienda/cursos/curs-presencial-mossos-desquadra-2026-30-hores/",
        created_at: "2026-03-30 00:00:10",
        start_at: "2026-03-30 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1202/image_h",
            portrait: "/1202/image_v",
        },
        hero: {
            firstTitle: "Curs Presencial Mossos d'Esquadra",
            secondTitle: "Convocatòria 2026",
            thirdTitle: "**Prepara Mossos amb estructura, criteri i confiança:** 30 hores presencials que marquen la diferència el dia de l'examen.",
            landscape: "/1202/hero_h",
            portrait: "/1202/hero_v",
        },
        parent: 1202,
        evolmind: {
            course_id: 1267,
            group_id: [3229],
        },
    },
    // 1229. Curs Presencial Mossos d'Esquadra (2026) - Grup Diumenge Matí
    {
        id: 1229,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-presencial-mossos-2026-30-hores-g2",
        title: "Curs Presencial Mossos d'Esquadra 2026 (30 hores) - Grup 2 - Diumenge Matí",
        name: "Curs Presencial Mossos d'Esquadra 2026 (30 hores) - Grup 2 - Diumenge Matí",
        short: "Curs Presencial Mossos - Grup 2 (Diumenge Matí)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "Prepara Mossos amb estructura, criteri i confiança: 30 hores presencials que marquen la diferència el dia de l’examen",
        enabled: true,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 299.99,
        // offer: 299.99,
        // offer_message: "Oferta de llançament!",
        // offer_text: "Oferta de llançament!",
        shipment: 0.0,
        images: ["/1202/image_h"],
        link: "/tienda/cursos/curs-presencial-mossos-desquadra-2026-30-hores/",
        created_at: "2026-03-30 00:00:10",
        start_at: "2026-03-30 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1202/image_h",
            portrait: "/1202/image_v",
        },
        hero: {
            firstTitle: "Curs Presencial Mossos d'Esquadra",
            secondTitle: "Convocatòria 2026",
            thirdTitle: "**Prepara Mossos amb estructura, criteri i confiança:** 30 hores presencials que marquen la diferència el dia de l'examen.",
            landscape: "/1202/hero_h",
            portrait: "/1202/hero_v",
        },
        parent: 1202,
        evolmind: {
            course_id: 1267,
            group_id: [3226],
        },
    },
];
exports.default = products;
